<template>
    <div>
        <Panel id="user_two_fa_filter" :title="$t('Filter Users')">
            <CicTextbox
                id="username_search_text"
                :placeholder="$t('Search By User')"
                :value="filterText"
                clearable
                @input="filter"
                @keyup.enter="handleSearch"
            />
        </Panel>

        <UserTwoFATable id="user_two_fa_table" :search-text="searchText" />
        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import UserTwoFATable from './UserTwoFATable';
    import './styles/userTwoFA.scss';

    export default {
        name: 'User2FARoutes',
        components: {
            CicTextbox,
            Panel,
            UserTwoFATable,
        },

        data() {
            return {
                filterText: '',
                searchText: '',
            };
        },

        methods: {
            filter(val) {
                this.filterText = val;
            },

            handleSearch() {
                this.searchText = this.filterText;
            },
        },
    };
</script>
